import type { IPermit } from "@/types/explore"

const STATUS_CONFIG: Record<number, { label: string; color: string }> = {
  2: { label: "Autorise", color: "rgb(34, 197, 94)" },
  4: { label: "Annule", color: "rgb(239, 68, 68)" },
  5: { label: "Commence", color: "rgb(234, 179, 8)" },
  6: { label: "Termine", color: "rgb(59, 130, 246)" },
}

const TYPE_DAU_LABELS: Record<string, string> = {
  PC: "Permis de construire",
  DP: "Declaration prealable",
  PA: "Permis d'amenager",
  PD: "Permis de demolir",
}

function formatDate(date: string | Date | null | undefined): string | null {
  if (!date) return null
  const d = new Date(date)
  if (isNaN(d.getTime())) return null
  return d.toLocaleDateString("fr-FR")
}

function buildAddress(permit: IPermit): string | null {
  const parts = [permit.ADR_NUM_TER, permit.ADR_LIBVOIE_TER, permit.ADR_CODPOST_TER].filter(Boolean)
  return parts.length > 0 ? parts.join(" ") : null
}

interface PCPopupProps {
  permit: IPermit
}

export const PCPopup = ({ permit }: PCPopupProps) => {
  const status = STATUS_CONFIG[permit.ETAT_DAU]
  const typeLabel = TYPE_DAU_LABELS[permit.TYPE_DAU] || permit.TYPE_DAU
  const date = formatDate(permit.DATE_REELLE_AUTORISATION || permit.DPC_AUT)
  const address = buildAddress(permit)
  const housing = permit.NB_LGT_TOT_CREES
  const surface = permit.SUPERFICIE_TERRAIN

  return (
    <div style={{ maxWidth: 450, fontSize: 14, lineHeight: 1.5, paddingRight: 20 }}>
      {/* Header: status badge + type */}
      <div className="flex items-center gap-1.5 mb-1.5">
        {status && (
          <span
            className="text-white text-[11px] font-semibold px-2 py-px rounded-full"
            style={{ backgroundColor: status.color }}
          >
            {status.label}
          </span>
        )}
        <span className="font-semibold text-xs text-gray-700">{typeLabel}</span>
      </div>

      {/* Date */}
      {date && <div className="text-gray-500 text-xs mb-1">{date}</div>}

      {/* Applicant */}
      {permit.DENOM_DEM && (
        <div className="mb-1">
          <span className="font-medium">{permit.DENOM_DEM}</span>
          {permit.SIREN_DEM && (
            <a
              href={`https://www.pappers.fr/entreprise/${permit.SIREN_DEM}`}
              target="_blank"
              rel="noopener noreferrer"
              className="ml-1.5 text-[11px] text-blue-500"
              onClick={(e) => e.stopPropagation()}
            >
              Pappers {"\u2197"}
            </a>
          )}
        </div>
      )}

      {/* Key metrics */}
      {(housing > 0 || surface > 0) && (
        <div className="flex gap-3 mb-1 text-xs text-gray-700">
          {housing > 0 && (
            <span>
              {housing} logement{housing > 1 ? "s" : ""}
            </span>
          )}
          {surface > 0 && (
            <span>
              {surface.toLocaleString("fr-FR")} m{"\u00B2"}
            </span>
          )}
        </div>
      )}

      {/* Address */}
      {address && <div className="text-[11px] text-gray-400">{address}</div>}
    </div>
  )
}
